import { createCn } from 'cn/config'

/**
 * The class merger every component uses: shadcn's `cn`, a drop-in for `twMerge(clsx(...))`,
 * taught the theme's own utilities, as DealerDrive's is.
 *
 * It decides what a `text-*` class is by its suffix: a t-shirt size or a length is a font size,
 * anything else a colour. `text-2xs`, `text-13` and `text-15` come from `--text-*` in
 * `styles/globals.css`, so to the stock tables they read as colours, and a later colour class
 * (`text-muted-foreground`) silently dropped them. The same goes for `shadow-card`, which is a
 * shadow, not a shadow colour. A new `--text-*` size or named shadow goes in here too.
 */
export const cn = createCn({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', '13', '15'] }],
      shadow: [{ shadow: ['card'] }],
    },
  },
})
